import React, {useState, useEffect,} from 'react';
import {Link, withRouter } from 'react-router-dom';
import styled from 'styled-components';
import DataTable from '../Components/DataTable';
import NewDataTablePC from '../Components/NewDataTablePC';
import NewDataTableMobile from '../Components/NewDataTableMobile';
import { BORDER_COLOR, GRAY_COLOR, V2_BLACK_COLOR, V2_BORDER_COLOR, V2_ACTIVE_COLOR, V2_INACTIVE_TEXT_COLOR, V2_INACTIVE_COLOR, V2_BACKGROUND_COLOR, V2_POINT_COLOR, BLUE_COLOR, V2_BUTTON_COLOR, V2_INACTIVE_BORDER_COLOR } from '../config/color';
import moment from 'moment';
import { watch, seller } from "../config/api";
import useAsync from "../config/useAsync";
import SearchIcon from "../assets/image/Search.png";
import DownArrow from "../assets/image/down.png";
import ClockIcon from '../assets/image/clock.png';
import GAEvent from '../utils/googleAnalytics';
import Ranking from '../Components/Ranking';

// import Accordion from '../Components/Accordion';
// import Card from '../Components/Card';

const content = [
  {
    question: '시계의 가격은 어떤 방식으로 책정되나요?',
    answer: `트레져러에 표시되는 가격은 빈티지(리셀)매장에서 판매하는 가격을 기준으로 합니다. 시계 판매 사이트, 직거래 게시판(커뮤니티), 해외 거래 사이트( [kakaku.com](http://kakaku.com), chrono24 등)에서 직거래가와 중고 리테일 가격을 지속적으로 업데이트 받아, 합리적인 하이엔드 시계의 기준 가격을 제시합니다.`
  },
  {
    question: '왜 트러져러 가격은 정확한가요?',
    answer: `전세계의 시세와 한국 시세, 리테일 및 직거래, 경매 데이터를 기반으로 가중평균내어 가장 정확한 판매가격을 제시하고 있습니다. 모든 로렉스의 가격은 중고S급 기준이나 스탬핑, 시리얼, 생산연도 등에 따라서 모델마다 편차가 있을 수 있습니다.`
  },
  {
    question: '업체 랭킹 기준은 어떻게 되나요?',
    answer: `트레져러의 업체 랭킹 기준은 시계 판매 가격, 판매 중인 시계 수, 서비스 등 여러 방면에 대해 자체 평가 후 이에 따라 매주 순위가 업데이트 됩니다.`
  },
  {
    question: '어떤 종류의 시계를 서비스하나요?',
    answer: `트레져러는 명품 중고 시계 ( 오메가, 롤렉스, 오데마피게, 파텍필립, 까르띠에, IWC, 브레게 등) 위주로 현재 서비스를 제공하고 있습니다. 추후에 더 많은 브랜드가 추가될 예정입니다.`
  },
  {
    question: '제 시계를 등록할 수 있나요?',
    answer: `개인 거래 중개 기능은 곧 오픈 예정이며, 3월중에 런칭할 계획입니다. 그 전까지는 얼마야 앱에 물품을 등록하시면 매입/대출 서비스를 이용하실 수 있습니다. 상단 얼마야 링크를 클릭해주세요`
  }
];

const orderList = [
  '인기순', '유동성', '최고가격', '최저가격'
]


const MainWrapper = styled.div`
  width: 100%;
  font-size: 0.8125rem;
  font-weight: 400;
  min-height: 100vh;
  padding-top: 60px;
  @media (max-width: 768px) {
    padding-top: 80px;
  }
`;

const MainContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const MainSectionArticle = styled.div`
  width: 1440px;
  display: flex;
  align-items: center;
  flex-direction: column;
  @media (max-width: 768px) {
    padding: 0px;
  }
`;

const BorderArea = styled.div`
  width: 100%;
  /* border: 1px solid ${BORDER_COLOR}; */
  padding: 10px;
`

const Title = styled.h1`
  font-size: 1.21875rem;
  font-family: 'SpoqaHanSans-Bold';
`;

const SpaceBetween = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e7eaf3 !important;
  padding-bottom: 0.75rem !important;
`

const ListTitle = styled.h1`
  font-size: 1.21875rem;
`;

const ListBox = styled.div`
  /* margin-top: 0.75rem !important; */
  width: 100%;
  @media (max-width: 768px) {
    margin: 0 !important;
  }
`;

const ListBoxTable = styled.div`
  flex: 1 1 auto;
  min-height: 1px;
  /* padding: 0.75rem; */
  @media (max-width: 768px) {
    padding: 0px;
  }
`;

const HomeTitleWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  padding: 0 20px;
  color: ${V2_BLACK_COLOR};
  font-size: 32px;
  line-height: 42px;
  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 24px;
  }
`

const HomeTitle = styled.h2`
  font-weight: 400;
  @media (max-width: 768px) {
    font-weight: 600;
  }
`

const TableShowHidePC = styled.div`
  display: block;
  @media (max-width: 768px) {
    display: none;
  }
`

const TableShowHideMobile = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: block;
  }
`

const SearchWrap = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  padding-bottom: 40px;
  margin-right: 20px;
  margin-left: 20px;
  @media (max-width: 768px) {
    margin-top: 20px;
    padding-bottom: 30px;
  }
`

const SearchBox = styled.div`
  padding: 12px 30px;
  border: 2px solid rgba(150, 157, 177, 0.75);
  border-radius: 14px;
  display: flex;
  flex-direction: row;
  align-items: center;
  @media (max-width: 768px) {
    border: 1px solid #969DB1;
    padding: 12px 24px;
  }
`

const SearchBoxText = styled.input`
  font-size: 18px;
  color: #ACB1C1;
  font-weight: 400;
  border: none;
  background-color: ${V2_BACKGROUND_COLOR};
  &:focus {
    outline: none;
  }
  ::placeholder {
    color: #ACB1C1;
  }
  @media (max-width: 768px) {
    font-size: 16px;
  }
`

const Image = styled.img`
  width: 20px;
  @media (max-width: 768px) {
    width: 14px;
  }
`;

const UpdateTextContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-bottom: 15px;
  @media (max-width: 768px) {
    margin-bottom: 0px;
    padding: 0 20px;
    margin-top: 40px;
  }
`

const UpdateTextWrap = styled.div`
  width: 678px;
  padding: 0 50px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  color: #748FB5;
  @media (max-width: 768px) {
    width: 100%;
    padding: 0px;
  }
`

const OrderContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-bottom: 20px;
  @media (max-width: 768px) {
    margin-bottom: 0px;
    padding: 0 20px;
    margin-top: 20px;
  }
`

const OrderWrap = styled.div`
  width: 678px;
  padding: 0 40px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: center;
  @media (max-width: 768px) {
    width: 100%;
    padding: 0px;
    justify-content: space-between;
  }
`

const SortBtn = styled.button`
  cursor: pointer;
  background-color: ${props => props.current ? `${V2_ACTIVE_COLOR}` : 'white'};
  border-radius: 40px;
  margin-bottom: 0px;
  color: ${props => props.current ? 'rgba(255,255,255, 0.75)' : `${V2_ACTIVE_COLOR}`};
  letter-spacing: 0.125rem;
  font-weight: 400;
  outline: none;
  border: none;
  font-size: 16px;
  padding: 16px 36px;
  @media (max-width: 768px) {
    font-size: 16px;
    padding: 8px 15px;
    margin-bottom: 14px;
    letter-spacing: 0;
  }
`


const FAQWrapper = styled.div`
  width: 678px;
  padding: 0 40px;
  margin-top: 40px;
  @media (max-width: 768px) {
    width: 100%;
    padding: 0 20px;
    margin-top: 20px;
  }
`

const AccordionWrapper = styled.button`
  width: 100%;
  display: flex;
  flex-direction: column;
  /* margin-top: 25px; */
  background-color: ${props => (props.showCollapse ? 'white' : 'transparent')};
  border-radius: ${props => (props.showCollapse ? '16px' : '0px')};
  padding: ${props => (props.showCollapse ? '20px' : '15px')};
  border: none;
  outline: none;
`

const AccordionContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${props => (props.showCollapse ? '20px' : '0px')};
`

const AccordionTitle = styled.div`
  color: ${props => (props.showCollapse ? '#272E35' : '#6E757C')};
  font-weight: ${props => (props.showCollapse ? '600' : '400')};
  font-size: ${props => (props.showCollapse ? '18px' : '14px')};
  @media (max-width: 768px) {
    font-size: ${props => (props.showCollapse ? '16px' : '14px')};
  }
`

const AccordionItem = styled.div`
  overflow: hidden;
  transition: max-height 0.3s cubic-bezier(1, 0, 1, 0);
  height: auto;
  max-height: 9999px;
`

const AccordionContent = styled.div`
  & + * {
    padding: 1em 1.5em;
  }
`

export default ({ history }) => {
  const [keyword, setKeyword] = useState("");
  const [searchList, setSearchList] = useState([]);
  const [itemList, setItemList] = useState([]);
  const [sellerList, setSellerList] = useState([]);
  const [sortType, setSortType] = useState(0);
  const [showCollapse, setShowCollpase] = useState(-1);

  useEffect(() => {
    const getWatchData = async () => {
      try {
        const r = await watch.getWatchData();
        setItemList(r.data.data.sort((a, b) => b.priority - a.priority));
        
      } catch(e) {
        console.log(e)
      }
    }

    const getSellerList = async () => {
      try {
        const r = await seller.getSeller();
        setSellerList(r.data.data);
      } catch(e) {
        console.log(e)
      }
    }
    
    getWatchData();
    getSellerList();
  }, [])

  const _onChangeText = event => {
    setKeyword(event.target.value);
    GAEvent('Search', '검색', event.target.value);
  };

  useEffect( async () => {
    try {
      const results = await watch.getWatchSearchData(keyword)
      setItemList(results.data.data.sort((a, b) => b.priority - a.priority));
    } catch(e) {
      console.log(e)
    }
  }, [keyword]);

  const _onClickSorting = i => {
    let item = [];
    if (i === 0) {
      // item = [...itemList].sort((a, b) => a.itemId - b.itemId);
      item = [...itemList].sort((a, b) => b.priority - a.priority);
      setItemList(item);
      GAEvent('TAB', '분류', '인기순')
    } else if (i === 1) {
      item = [...itemList].sort((a, b) => b.priority - a.priority);
      setItemList(item);
      GAEvent('TAB', '분류', '유동성')
    } else if (i === 2) {
      item = [...itemList].sort((a, b) => b.medianPrice[b.medianPrice.length-1] - a.medianPrice[a.medianPrice.length-1]);
      setItemList(item);
      GAEvent('TAB', '분류', '최고가격')
    } else if (i === 3) {
      item = [...itemList].sort((a, b) => a.medianPrice[a.medianPrice.length-1] - b.medianPrice[b.medianPrice.length-1]);
      setItemList(item);
      GAEvent('TAB', '분류', '최저가격')
    }
    setSortType(i);
  };

  const _onShowCollpase = (o, i) => {
    GAEvent('FAQ', '분류', o.question);
    if(showCollapse === i) {
      setShowCollpase(-1);
    } else {
      setShowCollpase(i);
    }
  }

  return (
    <MainWrapper>
      <MainContainer>
        <MainSectionArticle>
          <Ranking sellerList={sellerList} />
          <HomeTitleWrap>
            <HomeTitle>로렉스 가격, 트레져러에서</HomeTitle>
            <HomeTitle>매일매일 업데이트 받으세요.</HomeTitle>
          </HomeTitleWrap>
          <FAQWrapper>
            {content.map((o, i) => {
              return (
                <AccordionWrapper showCollapse={showCollapse === i} onClick={() => _onShowCollpase(o, i)} >
                  <AccordionContainer showCollapse={showCollapse === i}>
                    <AccordionTitle showCollapse={showCollapse === i}>{o.question}</AccordionTitle>
                    <p style={{width: 18, transform: showCollapse === i ? 'rotate(180deg)' : 'rotate(0deg)'}}>
                      <img style={{width: '100%'}} src={DownArrow} />
                    </p>
                  </AccordionContainer>
                  {showCollapse === i && (
                    <div>
                      <p style={{color: '#6E757C', textAlign: 'left', paddingBottom: 10, lineHeight: '24px'}}>{o.answer}</p>
                    </div>
                  )}
                </AccordionWrapper>
              )
            })}
          </FAQWrapper>
          <ListBox>
            <ListBoxTable>
              <SearchWrap>
                <SearchBox>
                  {/* <form>
                    <fieldset> */}
                      <SearchBoxText
                        type="text"
                        value={keyword}
                        onChange={_onChangeText}
                        // onChange={_onChangeText}
                        size="13"
                        placeholder="모델명으로 검색" />
                    {/* </fieldset>
                  </form> */}
                  <p>
                    <Image src={SearchIcon} alt="SearchIcon" />
                  </p>
                </SearchBox>
              </SearchWrap>
              <UpdateTextContainer>
                <UpdateTextWrap>
                  <div style={{display: 'flex', alignItems: 'center'}}>
                    <p style={{width: 14, marginRight: 4}}>
                      <img style={{width: '100%'}} src={ClockIcon} />
                    </p>
                    <p>마지막 업데이트: {moment().format('YYYY. MM. DD')} 09:00PST</p>
                  </div>
                </UpdateTextWrap>
              </UpdateTextContainer>
              <OrderContainer>
                <OrderWrap>
                  {orderList.map((o, i) => {
                    return (
                      <div>
                        <SortBtn
                          current={sortType === i}
                          onClick={() => _onClickSorting(i)}>
                            {o}
                        </SortBtn>
                      </div>
                    )
                  })}
                </OrderWrap>
              </OrderContainer>
              <TableShowHidePC>
                <NewDataTablePC getWatchData={itemList} history={history} />
              </TableShowHidePC>
              <TableShowHideMobile>
                <NewDataTableMobile getWatchData={itemList} />
              </TableShowHideMobile>
              {/* <DataTable getWatchData={getWatchData} /> */}
            </ListBoxTable>
          </ListBox>
        </MainSectionArticle>
      </MainContainer>
    </MainWrapper>
  )
}